export const CONTINUE_CTA_TEXT_MOBILE = "Continue to freeze price";
export const CONTINUE_CTA_TEXT = "Choose room and freeze price";